module.exports = __webpack_public_path__ + "img/ocean-protocol.37721c57.svg";